import React from 'react'
import styled from 'styled-components'
import { media } from 'styles/media'

import ButtonLink from 'components/display/ButtonLink'
import LazyImage from 'components/display/LazyImage'
import {
  SectionTitle,
  HeadingXxl,
  ParagraphSm,
} from 'components/display/Typography'
import { giftingImages } from '../content'

const Banner = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-core-50']?.value};
  position: relative;

  ${media.xl`
    background-color: ${({ theme }) => theme?.['-ds-core-100']?.value};
  `}
`

const BannerInner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`

const Image = styled.div`
  width: 100%;
  height: 100%;
  margin-top: -20%;

  .desktop-only {
    display: none;
  }

  img {
    object-position: top;
  }

  ${media.md`
    width: 40%;
    height: auto;
    margin-top: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    .mobile-only {
      display: none;
    }

    .desktop-only {
      display: block;
    } 

    img {
      margin-top: 0;
      object-position: left;
    }
  `}

  ${media.xl`
    width: 55%;
  `}
`
const Content = styled.div`
  padding: 45px 20px;
  width: 100%;

  ${media.md`
    width: 60%;
  `}

  ${media.xl`
    padding: 80px 100px 80px 16px;
    margin: 0;
    width: 45%;
  `}

  ${HeadingXxl} {
    margin-bottom: 11px;
    ${media.md`
      margin-bottom: 32px;
    `}
  }

  ${ParagraphSm} {
    margin-bottom: 32px;
  }
`

const Gifting = () => {
  return (
    <Banner>
      <BannerInner>
        <Content>
          <SectionTitle>Gifting</SectionTitle>
          <HeadingXxl>
            Give the gift of a soul-fulfilling Riparide escape
          </HeadingXxl>
          <ParagraphSm>
            Perfect for anyone on the run from everyday life. Whether it&apos;s
            for a special occasion or to reward an employee, we can all use a
            little push to get outdoors and do something to get our feet dirty,
            hair messy, and soul sparkling.
          </ParagraphSm>
          <ButtonLink href="/vouchers" inline compact uppercase={false}>
            Buy a voucher
          </ButtonLink>
        </Content>
        <Image>
          <LazyImage
            className="desktop-only"
            data-src={giftingImages.desktop.large.url}
            data-srcset={`
            ${giftingImages.desktop.medium.url} ${giftingImages.desktop.medium.width}w,
            ${giftingImages.desktop.large.url} ${giftingImages.desktop.large.width}w,
            ${giftingImages.desktop.hero.url} ${giftingImages.desktop.hero.width}w,
          `}
          />
          <LazyImage
            className="mobile-only"
            data-src={giftingImages.mobile.large.url}
            data-srcset={`
            ${giftingImages.mobile.medium.url} ${giftingImages.mobile.medium.width}w,
            ${giftingImages.mobile.large.url} ${giftingImages.mobile.large.width}w,
            ${giftingImages.mobile.hero.url} ${giftingImages.mobile.hero.width}w,
          `}
          />
        </Image>
      </BannerInner>
    </Banner>
  )
}

export default Gifting
